import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PageWrapper, { PageCard, PageTitle, Para } from '../../components/Layout/PageWrapper';

function Contact() {
  return (
    <PageWrapper maxWidth={760}>
      <Helmet>
        <title>Contact Us |Car Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online</title>
        <meta name="description" content="ContactCar Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online for support, feedback, or partnership inquiries. We're here to help!" />
        <link rel="canonical" href="https://cargames.site/contact" />
      </Helmet>

      <PageCard>
        <PageTitle>Contact Us</PageTitle>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <Para>Hit a bump during your gaming experience? Not to worry.</Para>
            <Para>We're here to provide you with the best online gaming experience. Drop us a message and we'll get back to you as soon as possible.</Para>

            <div className="mt-6 flex flex-col gap-2.5">
              {[
                { icon: '📧', label: 'Email', value: 'info@cargames.com', href: 'mailto:info@cargames.com' },
                { icon: '🌐', label: 'Website', value: 'cargames.com', href: 'https://cargames.site' },
              ].map(({ icon, label, value, href }) => (
                <div key={label} className="flex items-center gap-3.5 p-4 rounded-xl bg-hover-theme border-theme">
                  <span className="text-2xl">{icon}</span>
                  <div>
                    <div className="text-[11px] font-bold uppercase tracking-wider text-muted-theme">{label}</div>
                    <a href={href} className="text-sm font-bold no-underline text-[#4f8ef7]">{value}</a>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 p-4 rounded-xl bg-[rgba(79,142,247,0.08)] border border-[rgba(79,142,247,0.2)]">
              <div className="text-sm font-bold mb-2 text-[#4f8ef7]">⚡ Quick Links</div>
              <div className="flex gap-2 flex-wrap mt-2">
                {[['Privacy Policy', '/privacy-policy'], ['Terms', '/terms'], ['DMCA', '/DMCA'], ['About', '/about']].map(([label, to]) => (
                  <Link key={to} to={to} className="text-xs no-underline px-2.5 py-1 rounded-md text-secondary-theme bg-card-theme border-theme">
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="w-44 h-44 rounded-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[rgba(79,142,247,0.15)] to-[rgba(168,85,247,0.15)] border-2 border-[rgba(79,142,247,0.2)]">
              <span className="text-5xl">🎮</span>
              <span className="text-xs font-bold text-muted-theme">Car Games</span>
            </div>
          </div>
        </div>
      </PageCard>
    </PageWrapper>
  );
}

export default Contact;
